"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.GraphQLClient = void 0;
var simple_cache_1 = __importDefault(require("simple.cache"));
var object_hash_1 = __importDefault(require("object-hash"));
var axios_1 = __importDefault(require("axios"));
var axios_retry_1 = __importDefault(require("axios-retry"));
var GraphQLClient = /** @class */ (function () {
    function GraphQLClient(endpoint) {
        var _this = this;
        this.runQuery = function (query, variables, cacheResponse, httpMethod) {
            if (httpMethod === void 0) { httpMethod = 'POST'; }
            if (_this.hasCacheItem(query, variables)) {
                return Promise.resolve(_this.getCacheItem(query, variables));
            }
            return _this.request(query, variables, cacheResponse, httpMethod);
        };
        this.runMutation = function (query, variables) {
            return _this.request(query, variables);
        };
        this.preload = function (query, variables, httpMethod) {
            if (httpMethod === void 0) { httpMethod = 'POST'; }
            _this.request(query, variables, true, httpMethod);
        };
        this.setHeaders = function (headers) {
            _this.client.defaults.headers.common = headers;
        };
        this.setHeader = function (key, value) {
            _this.client.defaults.headers.common[key] = value;
        };
        this.clearCache = function () {
            _this.cache.clear();
        };
        this.resetCache = function (query, variables) { return _this.cache.remove(_this.getCacheKey(query, variables)); };
        this.cache = simple_cache_1["default"]();
        this.client = axios_1["default"].create({
            baseURL: endpoint,
            headers: {
                'Content-Type': 'application/json'
            }
        });
        axios_retry_1["default"](this.client, {
            retryDelay: axios_retry_1["default"].exponentialDelay,
            retries: 8,
            retryCondition: function (error) { return error.isAxiosError && error.status !== 401; }
        });
    }
    GraphQLClient.prototype.request = function (query, variables, cacheResponse, httpMethod) {
        if (httpMethod === void 0) { httpMethod = 'POST'; }
        return __awaiter(this, void 0, void 0, function () {
            var body, postRequestConfig, requestConfig, singleLineQuery, queryVariables, response, e_1, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = { query: query };
                        if (variables) {
                            body.variables = variables;
                        }
                        postRequestConfig = {
                            method: 'POST',
                            data: JSON.stringify(body)
                        };
                        requestConfig = postRequestConfig;
                        if (httpMethod === 'GET') {
                            singleLineQuery = query
                                .replace(/\n/g, ' ')
                                .replace(/ +(?= )/g, '')
                                .trim();
                            queryVariables = undefined;
                            if (variables) {
                                queryVariables = JSON.stringify(variables);
                            }
                            requestConfig = {
                                method: 'GET',
                                params: __assign({ query: singleLineQuery }, (queryVariables ? { variables: queryVariables } : {}))
                            };
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, this.client.request(requestConfig)];
                    case 2:
                        response = _a.sent();
                        if (response.status !== 200)
                            throw Error('Invalid response');
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        return [4 /*yield*/, this.client.request(postRequestConfig)];
                    case 4:
                        response = _a.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        if (response.data.errors)
                            throw { response: response.data };
                        data = response.data.data;
                        if (cacheResponse)
                            this.setCacheItem(data, query, variables);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GraphQLClient.prototype.hasCacheItem = function (query, variables) {
        return this.cache.has(this.getCacheKey(query, variables));
    };
    GraphQLClient.prototype.getCacheItem = function (query, variables) {
        return this.cache.get(this.getCacheKey(query, variables));
    };
    GraphQLClient.prototype.setCacheItem = function (response, query, variables) {
        return this.cache.set(this.getCacheKey(query, variables), response);
    };
    GraphQLClient.prototype.getCacheKey = function (query, variables) {
        return object_hash_1["default"]({ query: query, variables: variables });
    };
    return GraphQLClient;
}());
exports.GraphQLClient = GraphQLClient;
exports["default"] = GraphQLClient;
//# sourceMappingURL=data:application/json;base64,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